import React, { useEffect, useReducer, useState } from "react";
import "../Style.css"; import "../Responsive.css";
import { useLocation } from "react-router-dom";
import Switch from "@mui/material/Switch";
import { Button, Divider } from "@mui/material";
import Loader from "./common/Loader";
import TextField from "@mui/material/TextField";
import { connectToStore } from "../data/store";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import Utils from "../core/Utils";
import { postAsync } from "../core/serviceClient";
import { useNavigate } from "react-router-dom";
import Input from "@mui/material/Input";
import { MaxFileSizeLimit, ReportMaxDateLimit, WarrantyDurationUnitsArray } from "../core/Constants";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteIcon from "@mui/icons-material/Delete";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import { getBusiness } from "../data/localSettingsActions";
import { useDispatch } from "react-redux";
import UserHelper from "../core/UserHelper";
import SideBarMenuItems from "./SideBarMenuItems";
import { SideBarMenuNames } from "../core/Constants";
import SettingsMenuItems from "./SettingsMenuItems";
import MessagePopup from "./common/MessagePopUp";
import BusinessHelper from "../core/BusinessHelper";
import { ConfirmTypes } from "../core/Constants";
import { ImageEnlarge } from "./common/ImageEnlarge";
import ConfirmPopup from "./common/ConfirmPopup";
import {
  LoginPage,
  AddNewServicePage,
  ServicesPage,
} from "../core/PageConstants";
import NumericTextField from "./common/controls/NumericTextField";
import SalesInfoComponent from "./common/SalesInfoComponent";
import { CanUseProductStockReport } from "../core/ModuleHelper";
import { CanUseWarrantyDetails } from "../core/ModuleHelper";
import ProductConfigComponent from "./common/ProductConfigComponent";
import { serviceItemReducer } from "./reducers/serviceItem/serviceItemReducer";
import { serviceItemActionTypes } from "./reducers/serviceItem/serviceItemActionTypes";
import { convertProductItemObject, getServiceItemProductsFromProduct } from "../helpers/productHelper";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CountryHelper from "../core/CountryHelper";
import moment from "moment";
import CustomAddProductSelection from "./common/CustomAddProductSelection";

const AddNewService = (props) => {
  document.title = "Add New Service";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [localSettings, setLocalSettings] = useState({});
  const location = useLocation();
  const [name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [servicecode, setservicecode] = useState("");
  const [serviceTime, setserviceTime] = useState("");
  const [postserviceTime, setpostserviceTime] = useState("");
  const [labour, setLabour] = useState(false);
  const [frequentlyused, setfrequentlyused] = useState(false);
  const [active, setActive] = useState(true);
  const [Allowreservation, setAllowreservation] = useState(false);
  const [Blockcalender, setblockcalender] = useState("");
  const [servicecategory, setservicecategory] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [serviceTypeDescription, setserviceTypeDescription] = useState("");
  const [serviceType, setserviceType] = useState("");
  const [taxPercentage, setTaxPercentage] = useState("");
  const [taxAmount, setTaxAmount] = useState("");
  const [TotalPrice, setTotalPrice] = useState("");
  const [cost, setcost] = useState("");
  const [priceExclusive, setPriceExclusive] = useState("");
  const [originallist, setOriginalList] = useState([]);
  const [Typelist, setTypelist] = useState([]);
  const [Catlist, setCatlist] = useState([]);
  const [ServiceList, setServiceList] = useState([]);
  const [filteredstafflist, setFilteredStafflist] = useState([]);

  const [isDropdown1, setIsDropdown1] = useState(false);
  const [isDropdown, setIsDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [confirmFor, setConfirmFor] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [enlargeImage, setEnlargeImage] = useState(false);
  const [isNavigateToService, setIsNavigateToService] = useState(false);
  const [selectedService, setselectedService] = useState(
    location.state && location.state.selectedService
      ? location.state.selectedService
      : {}
  );
  const [inclusiveOfTax, setInclusiveOfTax] = useState(false);
  // product Configuration
  const [serviceItems, itemDispatch] = useReducer(serviceItemReducer, []);
  const [isProductConfig, setIsProductConfig] = useState(false);
  const [productStockReportAvailable, setProductStockReportAvailable] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [reviewService, setReviewService] = useState(false);
  const [addPromotional, setAddPromotional] = useState(false);
  const [promotionalMessage, setPromotionalMessage] = useState("");
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetEndDate(),
    Utils.GetExtendedDate(),
  ]);
  const [actualPriceExclusive, setActualPriceExclusive] = useState("");
  const [actualMunicipalTaxAmount, setActualMunicipalTaxAmount] = useState("");
  const [actualtaxAmount, setActualTaxAmount] = useState("");
  const [isWarrantyDetail, setIsWarrantyDetail] = useState(false);
  const [warrantyDescription, setWarrantyDescription] = useState("");
  const [durationValue, setDurationValue] = useState();
  const [durationUnit, setDurationUnit] = useState();
  const [redemptionCount, setRedemptionCount] = useState();
  const [isOpenAddProductSelection, setIsOpenAddProductSelection] = useState(false);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [visibleProducts, setVisibleProducts] = useState([]);
  const [overallCategoryList, setOverallCategoryList] = useState([]);
  const [overallTypeList, setOverallTypeList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterFetchedProducts, setFilterFetchedProducts] = useState([]);

  const getServiceItemObj = (item) => {
    return convertProductItemObject(item);
  };

  const populateServiceItems = (selectedService) => {
    itemDispatch({
      type: serviceItemActionTypes.Clear,
    });
    if (!Utils.IsNullOrEmptyArray(selectedService)) {
      selectedService.forEach((service, index) => {
        var newItem = getServiceItemObj(service);
        if (!Utils.IsNullOrEmpty(newItem)) {
          newItem.Sequence = index;
          itemDispatch({
            type: serviceItemActionTypes.Add,
            value: newItem,
          });
        }
      });
    }
  };

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    } else if (isNavigateToService) navigate(ServicesPage.Path);
  };

  const useProductConfig = () => {
    if (productStockReportAvailable === true) {
      if (labour === true) {
        setIsProductConfig(false);
      } else {
        setIsProductConfig(true);
      }
    } else {
      setIsProductConfig(productStockReportAvailable);
    }
  };
  const handleCheckboxChange = (event, rows) => {
    var tempCheckedItems = [...checkedItems];
    if (event.target.checked) {
      tempCheckedItems.push(rows);
    } else {
      var itemToRemove = tempCheckedItems.findIndex((i) => i.id === rows.id);
      tempCheckedItems.splice(itemToRemove, 1);
    }
    setCheckedItems(tempCheckedItems);
  };

  const handleSwitchChange = (event) => {
    setIsDropdown1(event.target.checked);
    setservicecategory("");
  };
  const handleSwitchType = (event) => {
    setIsDropdown(event.target.checked);
    setserviceType("");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let errorMsg = "";

    if (Utils.IsNullOrEmpty(name)) {
      errorMsg += "Please enter a proper Name.<br />";
    }
    if (Utils.IsNullOrEmpty(Description)) {
      errorMsg += "Please enter a proper Description.<br />";
    }
    if (Utils.IsNullOrEmpty(servicecode)) {
      errorMsg += "Please enter a valid Service Code.<br />";
    }

    if (Utils.IsNullOrEmpty(priceExclusive)) {
      errorMsg += "Please enter Price Exclusive Tax.<br />";
    }
    if (
      serviceItems.some((c) => c.Quantity === 0 || c.Quantity === "")
    ) {
      errorMsg += "Quantity must be greater than 0.<br />";
    }
    if (Utils.IsNullOrEmpty(warrantyDescription) && isWarrantyDetail === true) {
      errorMsg += "Please enter the Warranty Description.<br />";
    }

    if (!Utils.IsNullOrEmpty(errorMsg)) {
      setMsgText(errorMsg);
      setMsgOpen(true);
    } else {
      if (!Utils.IsNullOrEmptyObject(selectedService)) {
        setConfirmFor("Update");
      } else {
        setConfirmFor("Submit");
      }
      setConfirmText("Are you sure you want to save changes?");
      setConfirmOpen(true);
    }
  };
  const handleConfirmClose = (value) => {
    setConfirmOpen(false);
    if (value == ConfirmTypes.OK) {
      if (confirmFor == "Submit") {
        ServiceSubmit();
      }
      if (confirmFor == "Update") {
        editServiceDetails();
      }
    }
  };

  useEffect(() => {
    let localSetting = connectToStore();
    if (UserHelper.CheckPermission(AddNewServicePage, navigate, localSetting)) {
      setLocalSettings(localSetting);
      var productStockReport = CanUseProductStockReport(localSetting.business);
      setProductStockReportAvailable(productStockReport);
    }
  }, []);
  useEffect(() => {
    useProductConfig();
  }, [labour, productStockReportAvailable]);

  useEffect(() => {
    getServiceStaffs();
    getService();
  }, [localSettings]);

  const getImgObj = () => {
    return {
      url: Utils.IsNullOrEmpty(imageUrl)
        ? ""
        : imageUrl.startsWith("http")
          ? imageUrl
          : Utils.GetStringFromBase64(imageUrl),
      newFile: !Utils.IsNullOrEmpty(imageUrl) && !imageUrl.startsWith("http"),
    };
  };

  async function ServiceSubmit() {
    setIsLoading(true);
    const imgObj = getImgObj();
    let promotionStartTime = selectedDate[0];
    let promotionEndTime = selectedDate[1];
    var Service = {
      BusinessId: JSON.parse(localStorage.getItem("business-entity")).id,
      ShortDesc: name,
      Description: Description,
      Active: active,
      Code: servicecode,
      Cost: Utils.IsNullOrEmpty(cost) ? 0 : parseFloat(cost),
      Class: servicecategory,
      ClassDescription: categoryDescription,
      Fineline: serviceType,
      FinelineDescription: serviceTypeDescription,
      Price: Utils.IsNullOrEmpty(actualPriceExclusive)
        ? 0
        : parseFloat(actualPriceExclusive),
      TaxPercent: Utils.IsNullOrEmpty(taxPercentage)
        ? 0
        : parseFloat(taxPercentage),
      RetailPrice: Utils.IsNullOrEmpty(taxAmount) ? 0 : parseInt(taxAmount),
      Default: frequentlyused,
      imageUrl: imgObj.url,
      AvailableForReservation: Allowreservation,
      Labour: false,
      Service: true,
      IsMaterial: false,
      ServiceTime: Utils.IsNullOrEmpty(serviceTime) ? 0 : parseInt(serviceTime),
      PostServiceTime: Utils.IsNullOrEmpty(postserviceTime)
        ? 0
        : parseInt(postserviceTime),

      Staff: checkedItems,
      InclusiveOfTax: inclusiveOfTax,
      PriceIncludingTax: inclusiveOfTax ? Utils.ConvertToFloat(TotalPrice) : 0,
      ReviewProduct: reviewService,
      AddPromotional: addPromotional,
      PromotionalMessage: promotionalMessage,
      PromotionalStartTime: promotionStartTime,
      PromotionalEndTime: promotionEndTime,
      IsWarrantyDetail: isWarrantyDetail,
      WarrantyDescription: warrantyDescription,
      WarrantyDuration: durationValue,
      WarrantyRedemptionCount: redemptionCount,
      WarrantyDurationUnit: durationUnit
    };
    if (
      !labour &&
      productStockReportAvailable &&
      !Utils.IsNullOrEmptyArray(serviceItems)
    ) {
      Service = {
        ...Service,
        serviceItemProducts: serviceItems,
      };
    }
    let result2 = await postAsync(
      "Product/SaveProduct",
      {
        BusinessId: localSettings.business.id,
        NewProduct: true,
        Product: Service,
      },
      "",
      "Execute",
      "",
      [],
      imgObj.newFile
    );
    if (result2 && result2.data) {
      setIsNavigateToService(true);
      setMsgText("Service Added successfully");
      setMsgOpen(true);
    } else {
      setMsgText("Unable to process your request");
      setMsgOpen(true);
    }
    setIsLoading(false);
  }
  async function editServiceDetails() {
    setIsLoading(true);
    const imgObj = getImgObj();
    let promotionStartTime = selectedDate[0];
    let promotionEndTime = selectedDate[1];
    let ss = selectedService;

    ss["description"] = Description;
    ss["shortDesc"] = name;
    ss["code"] = servicecode;
    ss["cost"] = Utils.IsNullOrEmpty(cost) ? 0 : parseFloat(cost);
    ss["price"] = Utils.IsNullOrEmpty(actualPriceExclusive)
      ? 0
      : actualPriceExclusive;
    ss["taxPercent"] = Utils.IsNullOrEmpty(taxPercentage)
      ? 0
      : parseFloat(taxPercentage);
    ss["default"] = frequentlyused;
    ss["imageUrl"] = imgObj.url;
    ss["retailPrice"] = taxAmount;
    ss["price"] = Utils.IsNullOrEmpty(actualPriceExclusive) ? 0 : actualPriceExclusive;
    ss["postServiceTime"] = postserviceTime;
    ss["serviceTime"] = serviceTime;
    ss["fineline"] = serviceType;
    ss["finelineDescription"] = serviceTypeDescription;
    ss["class"] = servicecategory;
    ss["classDescription"] = categoryDescription;
    ss["availableForReservation"] = Allowreservation;
    ss["staff"] = checkedItems;
    ss["labour"] = false;
    ss["service"] = true;
    ss["isMaterial"] = false;
    ss["inclusiveOfTax"] = inclusiveOfTax;
    ss["priceIncludingTax"] = inclusiveOfTax ? Utils.ConvertToFloat(TotalPrice) : 0;
    ss["ReviewProduct"] = reviewService;
    ss['addPromotional'] = addPromotional;
    ss['promotionalMessage'] = promotionalMessage;
    ss['promotionalStartTime'] = promotionStartTime;
    ss['promotionalEndTime'] = promotionEndTime;
    ss['isWarrantyDetail'] = isWarrantyDetail;
    ss['warrantyDescription'] = warrantyDescription;
    ss['warrantyDuration'] = durationValue;
    ss['warrantyRedemptionCount'] = redemptionCount;
    ss['warrantyDurationUnit'] = durationUnit;
    if (
      !labour &&
      productStockReportAvailable &&
      !Utils.IsNullOrEmptyArray(serviceItems)
    ) {
      ss["serviceItemProducts"] = serviceItems;
    } else {
      ss["serviceItemProducts"] = null;
    }
    let result2 = await postAsync(
      "Product/SaveProduct",
      {
        BusinessId: localSettings.business.id,
        NewProduct: false,
        Product: ss,
      },
      "",
      "Execute",
      "",
      [],
      imgObj.newFile
    );
    if (result2 && result2.data) {
      setIsNavigateToService(true);
      setMsgText("Changes Saved successfully");
      setMsgOpen(true);
    } else {
      setMsgText("Unable to process your request");
      setMsgOpen(true);
    }
    setIsLoading(false);
  }
  async function getServiceStaffs() {
    if (localSettings.authenticated) {
      setIsLoading(true);
      var staffs = [];
      let result = await postAsync(
        "Account/GetAccount",
        {},
        "",
        "GetAll",
        "AllUsersForBusiness",
        [getBusiness().id]
      );
      staffs = result.data;
      var filteredstaffs = staffs.filter(
        (c) =>
          c.serviceStaff &&
          (c.role === "GlobalAdmin" || c.role === "BranchAdmin")
      );
      setFilteredStafflist(filteredstaffs);
      setIsLoading(false);
    }
  }
  const getService = async () => {
    if (localSettings.authenticated) {
      setIsLoading(true);
      let result1 = await postAsync(
        "Product/GetProduct",
        {},
        "",
        "GetAll",
        "AllProductsAndMaterialsForBusiness",
        [localSettings.business.id]
      );
      setIsNavigateToLogin(result1.isNavigateToLogin);
      if (result1.error) {
        setMsgOpen(true);
        setMsgText(result1.errorMessage);
      } else {
        if (!Utils.IsNullOrEmptyArray(result1.data)) {
          var Service = result1.data.filter(
            (item) =>
              (item.isMaterial == false && item.service == true) ||
              (item.labour == true && item.labour == false)
          );

          setServiceList(Service);

          setOriginalList(Service);
          const temTypellist = [];
          const temCatllist = [];
          Service.forEach((element) => {
            if (
              !Utils.IsNullOrEmpty(element.fineline) &&
              !temTypellist.includes(element.fineline)
            ) {
              temTypellist.push(element.fineline);
            }
            if (
              !Utils.IsNullOrEmpty(element.class) &&
              !temCatllist.includes(element.class)
            ) {
              temCatllist.push(element.class);
            }
          });
          setTypelist(temTypellist);
          setCatlist(temCatllist);
        }
      }
      setIsLoading(false);
    }
  };
  const UploadServiceImage = async (event) => {
    var file = event.target.files[0];

    if (file.size > MaxFileSizeLimit) {
      setAlertTitle("Warning");
      setMsgText(
        "Unable to upload. File size exceeds the maximum limit, please ensure that it's less than 10 MB."
      );
      setMsgOpen(true);
      return;
    }
    var base64 = await convertBase64(file);
    setImageUrl(base64);
  };
  const handleServicePhoto = (event) => {
    const fileInput = event.target;
    const ext = fileInput.value.match(/\.(.+)$/)[1];

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
        UploadServiceImage(event);
        break;
      default:
        setMsgOpen(true);
        setMsgText("/jpg,/jpeg,/png file types only allowed .");
        fileInput.value = "";
    }
  };
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const deleteServicePhoto = () => {
    setMsgText("Service image has been removed");
    setMsgOpen(true);
    setImageUrl("");
  };

  const closeImage = () => {
    setEnlargeImage(false);
  };
  const openImage = () => {
    setEnlargeImage(true);
  };
  useEffect(() => {
    populateSpare();
  }, [selectedService]);

  const populateSpare = () => {
    if (Utils.IsNullOrEmptyObject(selectedService)) {
      return;
    }
    setDescription(selectedService.description);
    setservicecode(selectedService.servicecode);
    setserviceTime(selectedService.serviceTime);
    setservicecode(selectedService.code);
    setName(selectedService.shortDesc);
    setActive(selectedService.active);
    setserviceType(selectedService.fineline);
    setserviceTypeDescription(selectedService.finelineDescription);
    setservicecategory(selectedService.class);
    setCategoryDescription(selectedService.classDescription);
    setAllowreservation(selectedService.availableForReservation);
    setcost(selectedService.cost);
    setTaxAmount(selectedService.retailPrice);
    setPriceExclusive(selectedService.price.toFixed(2));
    setActualPriceExclusive(selectedService.price);
    setImageUrl(selectedService.imageUrl);
    setfrequentlyused(selectedService.default);
    setTaxPercentage(selectedService.taxPercent);
    setblockcalender(selectedService.blockTimeOnCalendar);
    setserviceTime(selectedService.serviceTime);
    setpostserviceTime(selectedService.postServiceTime);
    setCheckedItems(selectedService.staff);
    setInclusiveOfTax(selectedService.inclusiveOfTax);
    setIsWarrantyDetail(selectedService.isWarrantyDetail);
    setWarrantyDescription(selectedService.warrantyDescription);
    populateServiceItems(selectedService.serviceItemProducts);
    setTotalPrice(Utils.IsNullOrEmpty(selectedService.priceIncludingTax) ? "" : selectedService.priceIncludingTax.toFixed(2));
    getServiceStaffs(selectedService.staff);
    setReviewService(selectedService.reviewProduct);
    setAddPromotional(selectedService.addPromotional || false);
    setPromotionalMessage(selectedService.promotionalMessage || "");
    let dateArray = [selectedService.promotionalStartTime, selectedService.promotionalEndTime];
    if (!selectedService.addPromotional) {
      dateArray = [new Date().toISOString(), new Date().toISOString()]
    }
    setDurationValue(selectedService.warrantyDuration);
    setDurationUnit(selectedService.warrantyDurationUnit);
    setRedemptionCount(selectedService.warrantyRedemptionCount);
    setSelectedDate(dateArray);
  };

  const handleServiceItemActions = (action) => {
    if (
      action.type === serviceItemActionTypes.Clear ||
      (serviceItems.length === 1 &&
        action.type === serviceItemActionTypes.Delete)
    ) {
      setShowDialog(false);
    }
    itemDispatch(action);
  };

  const addItemToCart = (product, isCustomProduct = false, sequenceValue = 0) => {
    configureDialog();
    var serviceItem = isCustomProduct
      ? product
      : getServiceItemProductsFromProduct(product);
    if (Utils.IsNullOrEmptyArray(serviceItems)) {
      serviceItem.Sequence = 1;
    } else {
      serviceItem.Sequence =
        serviceItems[serviceItems.length - 1].Sequence + 1;
    }
    if (sequenceValue) {
      serviceItem.Sequence = sequenceValue;
    }
    itemDispatch({
      type: serviceItemActionTypes.Add,
      value: serviceItem,
    });
  };
  const configureDialog = () => {
    if (!showDialog) {
      setShowDialog(true);
    }
  };

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText(
          "Please select a valid date range."
        );
        setMsgOpen(true);
      }
      else {
        const today = moment().startOf('day');
        let dateDiff = dateArray[1].diff(dateArray[0], "days");
        if (dateArray[0].isBefore(today) || dateArray[1].isBefore(today)) {
          setMsgText("Selected dates cannot be earlier than today.");
          setMsgOpen(true);
        } else {
          if (dateDiff > ReportMaxDateLimit) {
            setMsgText(
              "Please note that the maximum date range you can select is 366 days. You can choose any start date within the past 366 days, but the end date cannot exceed this limit."
            );
            setMsgOpen(true);
          } else {
            setSelectedDate(dateArray);
          }
        }

      }
    }
  };

  const OpenProductSelection = () => {
    const filteredIds = new Set(serviceItems.map(x => x.ProductId));
    const filterProducts = fetchedProducts.filter(
      (p) => !filteredIds.has(p.id)
    );
    setFilterFetchedProducts(filterProducts)
    setSelectedIds(serviceItems.map(item => item.ProductId))
    setIsOpenAddProductSelection(true);
    setVisibleProducts(filterProducts.slice(0, 1000));
  }
  const CloseProductSelection = () => {
    setIsOpenAddProductSelection(false);
  }
  const handleAddSelectedProducts = (selectedProductsIds) => {
    if (!Utils.IsNullOrEmptyArray(selectedProductsIds)) {
      const filteredItemIds = new Set(serviceItems.map(item => item.ProductId));
      const filteredSelectProductIds = new Set(
        [...selectedProductsIds].filter(id => !filteredItemIds.has(id))
      );

      let sequenceIndex = serviceItems.length;
      if (!Utils.IsNullOrEmptyArray(serviceItems)) {
        sequenceIndex = serviceItems[sequenceIndex - 1].Sequence
      }
      fetchedProducts.forEach((p) => {
        if (filteredSelectProductIds.size && filteredSelectProductIds.has(p.id)) {
          addItemToCart(p, false, ++sequenceIndex);
        }
      });
    }
  };
  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <ConfirmPopup
          confirmOpen={confirmOpen}
          confirmText={confirmText}
          onConfirmClose={handleConfirmClose}
        />
        <ImageEnlarge
          open={enlargeImage}
          imgSrc={imageUrl}
          onClose={closeImage}
        />
        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.BusinessSetup} />
            <Grid xs={12} className="content-sec">
              <Grid container direction="row" className="">
                <SettingsMenuItems
                  selectedMenu={BusinessHelper.GetServiceMenuName()}
                />
                <Grid flex="1" spacing={2} className="form-sec card white-bg">
                  <form
                    className="cs-form"
                    style={{ paddingBottom: "30px" }}
                    onSubmit={handleSubmit}
                  >
                    <Stack spacing={3}>
                      {Utils.IsNullOrEmpty(imageUrl) && (
                        <Stack direction="row" spacing={2}>
                          <label>
                            <AddAPhotoIcon style={{ "font-size": "120px", "opacity": "0.3" }} />
                            <Input
                              type="file"
                              name="myImage"
                              className="hide"
                              accept="image/png, image/jpeg, image/jpg"
                              onChange={(e) => handleServicePhoto(e)}
                            />
                          </label>
                        </Stack>
                      )}

                      {!Utils.IsNullOrEmpty(imageUrl) && (
                        <div className="card imgBox">
                          <img
                            alt="not found"
                            width={"150px"}
                            src={imageUrl}
                            onClick={openImage}
                          />
                          <br />
                          <button
                            className="p-0 mt-1 btn btn-default"
                            onClick={deleteServicePhoto}
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      )}

                      <Typography
                        level="h3"
                        component="h3"
                        fontWeight="600"
                        fontSize="1.2rem"
                        className="h3 m-0"
                      >
                        Tap to select Image
                      </Typography>
                    </Stack>

                    <Stack sx={{ minWidth: 120 }} spacing={2} className="mt-3">
                      <FormControl fullWidth>
                        <TextField
                          inputProps={{ style: { fontSize: 13 } }}
                          label="Name "
                          type="text"
                          value={name}
                          error={!name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Enter name"
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <TextField
                          inputProps={{ style: { fontSize: 13 } }}
                          label="Description "
                          type="text"
                          value={Description}
                          error={!Description}
                          onChange={(e) => setDescription(e.target.value)}
                          placeholder="Enter description"
                        />
                      </FormControl>
                      <Stack direction="row" spacing={2}>
                        <FormControl fullWidth>
                          <TextField
                            maxRows={5}
                            inputProps={{
                              style: { fontSize: 13 },
                              maxLength: 5,
                            }}
                            label="Service Code"
                            type="text"
                            value={servicecode}
                            error={!servicecode}
                            onChange={(e) => setservicecode(e.target.value)}
                            placeholder="Enter code"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <NumericTextField
                            inputProps={{ maxLength: 3 }}
                            value={serviceTime}
                            setValue={setserviceTime}
                            label="Service Time (Min)"
                            placeholder="Enter time"
                          />
                        </FormControl>
                        <FormControl fullWidth>
                          <NumericTextField
                            inputProps={{ maxLength: 3 }}
                            value={postserviceTime}
                            setValue={setpostserviceTime}
                            label="Post Service Time (Min)"
                            placeholder="Enter time"
                          />
                        </FormControl>
                      </Stack>
                      <br />
                      <Stack
                        direction="row"
                        spacing={5}
                        justifyContent="space-between"
                        style={{
                          border: "1px solid #cccccc",
                          "border-radius": "4px",
                        }}
                        className="font-size-14"
                      >
                        {!BusinessHelper.IsSalon() && (
                          <FormControl fullWidth>
                            <Box>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={labour}
                                    onChange={(e) => setLabour(e.target.checked)}
                                    InputLabelProps={{ shrink: true }}
                                    name="Labour"
                                    color="primary"
                                  />
                                }
                                value={labour}
                                label="Labour"
                                labelPlacement="start"
                              />
                            </Box>
                          </FormControl>
                        )}

                        <FormControl fullWidth>
                          <Box>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={frequentlyused}
                                  onChange={(e) =>
                                    setfrequentlyused(e.target.checked)
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  name="frequently used"
                                  color="primary"
                                />
                              }
                              value={frequentlyused}
                              label="Frequently Used"
                              labelPlacement="start"
                            />
                          </Box>
                        </FormControl>
                        <FormControl fullWidth>
                          <Box>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={active}
                                  onChange={(e) => setActive(e.target.checked)}
                                  InputLabelProps={{ shrink: true }}
                                  name="Active"
                                  color="primary"
                                />
                              }
                              value={active}
                              label="Active"
                              fontSize="1.5rem"
                              labelPlacement="start"
                            />
                          </Box>
                        </FormControl>
                        <FormControl fullWidth>
                          <Box>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={reviewService}
                                  onChange={(e) =>
                                    setReviewService(e.target.checked)
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  name="Review Service"
                                  color="primary"
                                />
                              }
                              value={reviewService}
                              label="Review Service"
                              labelPlacement="start"
                            />
                          </Box>
                        </FormControl>
                      </Stack>
                      <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="space-between"
                        style={{
                          border: "1px solid #cccccc",
                          "border-radius": "4px",
                        }}
                        className="font-size-14"
                      >
                        <FormControl fullWidth>
                          <Box>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={Allowreservation}
                                  onChange={(e) =>
                                    setAllowreservation(e.target.checked)
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  name="Allow Reservation"
                                  color="primary"
                                />
                              }
                              value={Allowreservation}
                              label="Allow Reservation"
                              labelPlacement="start"
                            />
                          </Box>
                        </FormControl>

                        <FormControl fullWidth>
                          <Box>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={Blockcalender}
                                  onChange={(e) =>
                                    setblockcalender(e.target.checked)
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  name="Block calender"
                                  color="primary"
                                />
                              }
                              value={Blockcalender}
                              label="Block Calender"
                              labelPlacement="start"
                            />
                          </Box>
                        </FormControl>
                      </Stack>
                      {(BusinessHelper.IsAutomobile(localSettings.business) && CanUseWarrantyDetails(localSettings.business)) && (
                        <>
                          <Stack
                            direction="row"
                            alignItems="baseline"
                            justifyContent="space-between"
                            className="m-0"
                          >
                            <Typography variant="h6" component="h3" className="section-title mt-3">
                              Warranty Details
                            </Typography>

                            <FormControlLabel
                              control={
                                <Switch
                                  checked={isWarrantyDetail}
                                  onChange={(e) => setIsWarrantyDetail(e.target.checked)}
                                  name="Warranty Detail"
                                  color="primary"
                                />
                              }
                              sx={{
                                '& .MuiFormControlLabel-label': {
                                  fontSize: '13px',
                                },
                              }}
                              label="Warranty Applicable"
                              labelPlacement="start"
                            />
                          </Stack>
                          {(isWarrantyDetail &&
                            // <FormControl fullWidth>
                            //   <TextField
                            //     inputProps={{ style: { fontSize: 13 } }}
                            //     label="Warranty Description"
                            //     value={warrantyDescription}
                            //     error={isWarrantyDetail && !warrantyDescription}
                            //     onChange={(e) => setWarrantyDescription(e.target.value)}
                            //     placeholder="Warranty Description"
                            //     multiline
                            //   />
                            // </FormControl>
                            <Box sx={{ width: "100%" }}>
                              <FormControl fullWidth sx={{ mb: 1 }}>
                                <TextField
                                  inputProps={{ style: { fontSize: 13 } }}
                                  label="Warranty Description"
                                  value={warrantyDescription}
                                  error={Boolean(isWarrantyDetail && !warrantyDescription)}
                                  onChange={(e) => setWarrantyDescription(e.target.value)}
                                  placeholder="Warranty Description"
                                  multiline
                                  minRows={3}
                                />
                              </FormControl>

                              <Grid container spacing={1} sx={{ mb: 1 }} style={{ marginTop: "9px" }}>

                                {/* Redemption Count */}
                                <Grid item xs={4}>
                                  <TextField
                                    label="Redemption Count"
                                    type="number"
                                    inputProps={{ maxLength: 3, min: 0, step: 1, style: { fontSize: 13 } }}
                                    value={redemptionCount ?? ""}
                                    onChange={(e) => {
                                      const v = e.target.value;
                                      if (v.length > 3) return;
                                      setRedemptionCount(v === "" ? "" : Math.max(0, Math.floor(Number(v))));
                                    }}
                                    fullWidth
                                  />
                                </Grid>

                                {/* Duration Value */}
                                <Grid item xs={4}>
                                  <TextField
                                    label="Duration"
                                    type="number"
                                    inputProps={{ maxLength: 3, min: 0, step: 1, style: { fontSize: 13 } }}
                                    value={durationValue ?? ""}
                                    onChange={(e) => {
                                      const v = e.target.value;
                                      if (v.length > 3) return;
                                      setDurationValue(v === "" ? "" : Math.max(0, Math.floor(Number(v))));
                                    }}
                                    fullWidth
                                  />
                                </Grid>

                                {/* Duration Unit */}
                                <Grid item xs={4}>
                                  <FormControl fullWidth>
                                    <InputLabel id="duration-unit-label" style={{ fontSize: 13 }}>
                                      Unit
                                    </InputLabel>

                                    <Select
                                      inputProps={{ min: 0, style: { fontSize: 20 } }}
                                      labelId="duration-unit-label"
                                      value={durationUnit || "Months"}
                                      label="Unit"
                                      style={{ height: "55px" }}
                                      sx={{ fontSize: 16 }}
                                      onChange={(e) => setDurationUnit(e.target.value)}
                                    >
                                      {WarrantyDurationUnitsArray.map((unit) => (
                                        <MenuItem key={unit} value={unit}>
                                          {unit}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </Box>
                          )}
                        </>
                      )}


                      <Typography
                        level="h3"
                        component="h3"
                        className="section-title mt-3"
                      >
                        {" "}
                        Service Classification
                      </Typography>

                      <Stack
                        direction="row"
                        alignItems="baseline"
                        justifyContent="space-between"
                        className="m-0"
                      >
                        <Typography
                          level="h4"
                          component="h4"
                          fontWeight="700"
                          fontSize="1.4rem"
                          className="h3"
                        >
                          Enter New Category:
                        </Typography>
                        <FormControlLabel
                          style={{ margin: "0 0 10px 0" }}
                          control={
                            <Switch
                              checked={isDropdown1}
                              onChange={handleSwitchChange}
                            />
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                      </Stack>
                      <Stack
                        direction="row"
                        spacing={2}
                        className="justify-content-between m-0"
                      >
                        {!isDropdown1 ? (
                          <FormControl fullWidth variant="outlined" margin="0">
                            <InputLabel id="Category-label">
                              Service Category
                            </InputLabel>
                            <Select
                              inputProps={{ style: { fontSize: 13 } }}
                              labelId="Category-label"
                              id="Category-select"
                              value={servicecategory}
                              onChange={(e) => setservicecategory(e.target.value)}
                              InputLabelProps={{ shrink: true }}
                              label="Service Category"
                              style={{ height: "51.5px" }}
                            >
                              {!Utils.IsNullOrEmptyArray(Catlist) &&
                                Catlist.map((item) => (
                                  <MenuItem value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        ) : (
                          <TextField
                            inputProps={{ style: { fontSize: 13 } }}
                            fullWidth
                            variant="outlined"
                            margin="0"
                            label="Service Category"
                            value={servicecategory}
                            onChange={(e) => setservicecategory(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter category"
                          />
                        )}
                        <FormControl fullWidth>
                          <TextField
                            inputProps={{ style: { fontSize: 13 } }}
                            fullWidth
                            variant="outlined"
                            margin="0"
                            label=" Service Category Description"
                            value={categoryDescription}
                            onChange={(e) =>
                              setCategoryDescription(e.target.value)
                            }
                            placeholder="Enter description"
                          />
                        </FormControl>
                      </Stack>
                    </Stack>

                    <Stack
                      direction="row"
                      alignItems="baseline"
                      justifyContent="space-between"
                    >
                      <Typography
                        level="h4"
                        component="h4"
                        fontWeight="700"
                        fontSize="1.4rem"
                        className="h3"
                      >
                        Enter New Type:
                      </Typography>
                      <FormControlLabel
                        style={{ margin: "0 0 10px 0" }}
                        control={
                          <Switch
                            checked={isDropdown}
                            onChange={handleSwitchType}
                          />
                        }
                        InputLabelProps={{ shrink: true }}
                      />
                    </Stack>
                    <Stack
                      direction="row"
                      spacing={2}
                      className="justify-content-between"
                    >
                      {!isDropdown ? (
                        <FormControl fullWidth variant="outlined" margin="0">
                          <InputLabel id="Category-label">
                            Service Type
                          </InputLabel>
                          <Select
                            inputProps={{ style: { fontSize: 13 } }}
                            labelId="Servicetype-label"
                            id="Servicetype-select"
                            value={serviceType}
                            onChange={(e) => setserviceType(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            label="Service Type"
                            style={{ height: "51.5px" }}
                          >
                            {!Utils.IsNullOrEmptyArray(Typelist) &&
                              Typelist.map((item) => (
                                <MenuItem value={item}>{item}</MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <TextField
                          inputProps={{ style: { fontSize: 13 } }}
                          fullWidth
                          variant="outlined"
                          margin="0"
                          label="Service Type"
                          value={serviceType}
                          onChange={(e) => setserviceType(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Enter service type"
                        />
                      )}
                      <FormControl fullWidth variant="outlined" margin="0">
                        <TextField
                          inputProps={{ style: { fontSize: 13 } }}
                          fullWidth
                          variant="outlined"
                          margin="0"
                          label="Service Type Description"
                          value={serviceTypeDescription}
                          onChange={(e) =>
                            setserviceTypeDescription(e.target.value)
                          }
                          placeholder="Enter description"
                        />
                      </FormControl>
                    </Stack>

                    <SalesInfoComponent
                      inclusiveOfTax={inclusiveOfTax}
                      setInclusiveOfTax={setInclusiveOfTax}
                      cost={cost}
                      setCost={setcost}
                      priceExclusive={priceExclusive}
                      setActualTaxAmount={setActualTaxAmount}
                      setActualMunicipalTaxAmount={setActualMunicipalTaxAmount}
                      setActualPriceExclusive={setActualPriceExclusive}
                      setPriceExclusive={setPriceExclusive}
                      taxPercentage={taxPercentage}
                      setTaxPercentage={setTaxPercentage}
                      totalPrice={TotalPrice}
                      setTotalPrice={setTotalPrice}
                      taxAmount={taxAmount}
                      setTaxAmount={setTaxAmount}
                      costMandatory={false}
                    />
                    {BusinessHelper.IsSalon() && <Stack
                      direction="row"
                      alignItems="baseline"
                      justifyContent="space-between"
                      className="m-0"
                    >
                      <Typography
                        level="h3"
                        component="h3"
                        className="section-title mt-3"
                      >
                        {" "}
                        Add Promotion
                      </Typography>
                      <FormControlLabel
                        style={{ margin: "0" }}
                        control={
                          <Switch
                            checked={addPromotional}
                            onChange={(e) => setAddPromotional(e.target.checked)}
                          />
                        }
                        InputLabelProps={{ shrink: true }}
                      />
                    </Stack>}
                    {BusinessHelper.IsSalon() && addPromotional && (
                      <>
                        <Stack
                          direction="row"
                          spacing={2}
                          className="justify-content-between m-0"
                        >
                          <FormControl fullWidth>
                            <TextField
                              inputProps={{ style: { fontSize: 13 } }}
                              label="Promotional message "
                              type="text"
                              value={promotionalMessage}
                              // error={!promotionalMessage}
                              onChange={(e) => setPromotionalMessage(e.target.value)}
                              placeholder="Enter promotional message"
                            />
                          </FormControl>
                        </Stack>
                        <Stack direction="row" mt={2} justifyContent="flex-end" style={{ height: "100%" }}>
                          <DateRangePicker
                            showLeadingZeros={true}
                            onChange={onDateChange}
                            value={selectedDate}
                            locale={CountryHelper.GetDateCulture(localSettings.country.Culture)}
                            clearIcon={null}
                            calendarIcon={
                              <CalendarMonthOutlinedIcon
                                style={{
                                  "font-size": "24px",
                                  "align-self": "center",
                                  color: "#666666",
                                }}
                              />
                            }
                          />
                        </Stack>
                      </>)
                    }

                    {isProductConfig && (
                      <>
                        <br />
                        <Box>
                          <Typography
                            level="h3"
                            component="h3"
                            fontWeight="700"
                            fontSize="1.6rem"
                            className="section-title"
                          >
                            Product Configuration
                          </Typography>
                          <br />
                          <Stack className="card">
                            <ProductConfigComponent
                              fromServiceSetup={true}
                              serviceItems={serviceItems}
                              handleItemAction={handleServiceItemActions}
                              onAddItem={addItemToCart}
                              setFetchedProducts={setFetchedProducts}
                              OpenProductSelection={OpenProductSelection}
                              setOverallCategoryList={setOverallCategoryList}
                              setOverallTypeList={setOverallTypeList}
                              setTypeList={setTypeList}
                            />
                          </Stack>
                        </Box>
                      </>
                    )}

                    <Stack className="mt-3">
                      <Typography
                        level="h3"
                        component="h3"
                        className="section-title"
                      >
                        Service Staff
                      </Typography>

                      {!Utils.IsNullOrEmptyArray(filteredstafflist) &&
                        filteredstafflist.map((rows, index) => (
                          <div key={index}>
                            <Stack direction="row" justifyContent="space-between">
                              <Stack>
                                <FormControl>
                                  <Typography
                                    level="h3"
                                    className="mt-1"
                                    component="h3"
                                    fontSize="18px"
                                    fontWeight="600"
                                  >
                                    {rows.firstName}
                                  </Typography>
                                  <Typography
                                    level="p"
                                    className="mb-1"
                                    component="p"
                                    fontSize="13px"
                                  >
                                    {rows.id}
                                  </Typography>
                                </FormControl>
                              </Stack>

                              <Stack
                                xs={2}
                                justifyContent="space-between"
                                alignContent="end"
                              >
                                <Checkbox
                                  size="large"
                                  checked={
                                    !Utils.IsNullOrEmptyObject(
                                      checkedItems.find((s) => s.id === rows.id)
                                    )
                                  }
                                  onChange={(e) => handleCheckboxChange(e, rows)}
                                  InputLabelProps={{ shrink: true }}
                                  input
                                />
                              </Stack>
                            </Stack>
                            <Divider />
                          </div>
                        ))}
                    </Stack>
                    <br />
                    {UserHelper.CanEdit() && (
                      <Stack
                        direction="row"
                        className="fixed-btn"
                      >
                        <Grid className="container"
                          justifyContent="end"
                        >
                          <Stack direction="row" justifyContent="end">
                            <FormControl>
                              <Button
                                type="submit"
                                variant="contained"
                                className="btn btn-primary"
                              >
                                Save
                              </Button>
                            </FormControl>
                          </Stack>
                        </Grid>
                      </Stack>
                    )}
                  </form>
                </Grid>
              </Grid>
              <CustomAddProductSelection
                open={isOpenAddProductSelection}
                overAllproducts={filterFetchedProducts}
                limit={1000}
                onCloseProductSelection={CloseProductSelection}
                visibleProducts={visibleProducts}
                setVisibleProducts={setVisibleProducts}
                categoryList={overallCategoryList}
                typeList={typeList}
                setTypeList={setTypeList}
                overAllTypeList={overallTypeList}
                handleAddSelectedProducts={handleAddSelectedProducts}
                selectedIds={selectedIds}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default AddNewService;
